import React from "react";
import { getFeaturesFour } from "../../mocks/features";
import { useTranslation } from "react-i18next";

export const FeatureSix = () => {
  const { t } = useTranslation();
  const features = getFeaturesFour(t);

  return (
    <section className="features-area-six">
      <div className="container">
        <div className="features-item-wrap-four features-item-wrap-six">
          <div className="row justify-content-center">
            {features.map((feature) => (
              <div key={feature.id} className="col-lg-4 col-md-6">
                <div className="features-item-four">
                  <div className="features-icon-four">
                    <i className={feature.icon}></i>
                  </div>
                  <div className="features-content-four">
                    <h4 className="title">{feature.title} </h4>
                    <p>{feature.subtitle}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
